export const getCustomRangeTrendTooltipTitle = (
  currentDatePeriod: string,
  previousDatesPeriod: string,
) => {
  return `(${currentDatePeriod}) compared with the preceding corresponding period (${previousDatesPeriod}).`;
};
